import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgMorphComponent } from './svg-morph.component';
import { SvgIconModule } from './../svg-icon';

@NgModule({
    declarations: [SvgMorphComponent],
    imports: [
        CommonModule,
        SvgIconModule
    ],
    exports: [
        SvgMorphComponent
    ]
})
export class SvgMorphModule { }
